import React from 'react'
import { DcOverlaySlider } from 'pixel-base'

interface Props {
  isOpen: boolean
  onClose: () => void
  title: string
  children: React.ReactNode
  footer?: React.ReactNode
  width?: string
}

const FinanceEntityDrawer: React.FC<Props> = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  width = '36%',
}) => {
  return (
    <DcOverlaySlider
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width={width}
    >
      <div style={{ padding: 20, display: 'grid', gap: 16 }}>
        {children}
        {footer}
      </div>
    </DcOverlaySlider>
  )
}

export default FinanceEntityDrawer
